module.exports = __webpack_public_path__ + "img/heavyPackage.3b70b48d.svg";